module.exports = __webpack_public_path__ + "img/mining_icon.f8455dee.svg";